import React, { useState, useRef, useEffect } from "react";
// import NavList from "./NavList";

const NavIcon = () => {
    const dropdownRef = useRef(null);
    const [open, setOpen] = useState(false);
    const [size, setSize] = useState(window.innerWidth);

    const toggleMenu = () => {
        setOpen(!open);
    };

    useEffect(() => {
        const pageClickEvent = (e) => {
            if (
                dropdownRef.current !== null &&
                !dropdownRef.current.contains(e.target)
            ) {
                setOpen(!open);
            }
        };

        if (open) {
            window.addEventListener("click", pageClickEvent);
        }

        return () => {
            window.removeEventListener("click", pageClickEvent);
        };
    }, [open]);

    const handleResize = () => {
        setSize(window.innerWidth);
    };

    useEffect(() => {
        window.addEventListener("resize", handleResize);
    }, []);

    return (
        <nav className="nav-container">
            <div className="nav-icon-container" onClick={toggleMenu}>
                <span className="nav-icon  top"></span>
                <span className="nav-icon middle"></span>
                <span className="nav-icon bottom"></span>
            </div>
            <div
                ref={dropdownRef}
                className={`nav-list ${open ? "open" : "closed"}`}
            >
                <ul>
                    <li>
                        <a href="#home">Home</a>
                    </li>
                    <li>
                        <a href="#about">About</a>
                    </li>
                    <li>
                        <a
                            href={`${
                                size < 500 ? "#mobile-menu" : "#desktop-menu"
                            }`}
                        >
                            Menu
                        </a>
                    </li>
                    <li>
                        <a
                            href={`${
                                size < 500
                                    ? "#mobile-reservations"
                                    : "#desktop-reservations"
                            }`}
                        >
                            Reservations
                        </a>
                    </li>
                    <li>
                        <a
                            href={`${
                                size < 500
                                    ? "#mobile-contact"
                                    : "#desktop-contact"
                            }`}
                        >
                            Contact Us
                        </a>
                    </li>
                </ul>
            </div>
        </nav>
    );
};

export default NavIcon;
